export default {
  namespaced: true,
  state: {
    petConcerns: [],
  },
  getters: {
    getPetConcerns(state) {
      return state.petConcerns.filter((concern) => concern.is_cx_appointment_concern);
    },
    getPrimaryPetConcerns(state, getters) {
      return getters.getPetConcerns.filter((concern) => concern.is_primary);
    },
  },
  actions: {
    async fetchPetConcerns({ commit }, payload) {
      await this.$app.$api.get('p/pet/concerns', { params: payload })
        .then((response) => commit('setPetConcerns', response.data.data))
        .catch(() => {});
    },
  },
  mutations: {
    setPetConcerns(state, data) {
      state.petConcerns = data;
    },
  },
};
